module.exports = __webpack_public_path__ + "static/media/cock-wearing-chasma.90bcbe6b.png";